import React from "react";
import { Flame, ShieldCheck, Truck } from "lucide-react";
import ViralOffersShowcase from "../components/ViralOffersShowcase";
import "./OfertasVirales.css";

export default function OfertasVirales() {
  return <main className="viral-offers-page">
    <header><span><Flame />Selección del momento</span><h1>Ofertas virales de <em>TikTok</em></h1><p>Descubre promociones especiales en los productos que están marcando tendencia. Elige tu oferta y realiza el pedido directamente por WhatsApp.</p><div><span><Truck />Envío gratis</span><span><ShieldCheck />Pago contra entrega</span></div></header>
    <ViralOffersShowcase />
  </main>;
}
